import type { ReferralPublicStatus } from '@/services/referralsService'

type Counts = Partial<Record<ReferralPublicStatus, number>>

function sum(counts: Counts, keys: ReferralPublicStatus[]) {
  return keys.reduce((total, key) => total + (counts[key] ?? 0), 0)
}

export function parceirosLeadMetrics(total: number, counts: Counts) {
  const fechados = sum(counts, ['ganho', 'pago'])
  const naoAvancaram = sum(counts, ['perdido'])
  const emAndamento = Math.max(0, total - fechados - naoAvancaram)
  return [
    { label: 'Leads enviados', value: total },
    { label: 'Em andamento', value: emAndamento },
    { label: 'Fechados', value: fechados },
    { label: 'Não avançaram', value: naoAvancaram },
  ]
}
